import React, { useMemo } from 'react';

import { Select } from '~/eds/src/components/Select/Select';
import { useDebouncedState } from '~/eds/src/hooks/useDebouncedState';
import { Option } from '~/eds/src/types/Option';
import { SharedSelectProps } from '~/eds/src/types/SharedSelectProps';
import { api } from '~/redux/api/createApi';

interface Props<M> extends SharedSelectProps<string, M> {
  extraOptions?: Option<string>[];
}
export const ClausesSelect = <M extends boolean>({
  value,
  onChange,
  name,
  extraOptions = [],
  ...rest
}: Props<M>) => {
  const [debouncedSearch, _search, setSearch] = useDebouncedState<string>('');
  const { data } = api.endpoints.getFilterSuggestions.useQuery({
    filterId: 'clause',
    query: debouncedSearch,
  });
  const options: Option<string>[] = useMemo(() => {
    if (data) {
      const optionsList = data.data.map(({ attributes }) => ({
        label: attributes.label,
        value: attributes.value,
      }));

      return [...extraOptions, ...optionsList];
    }
    return [];
  }, [data, extraOptions]);

  return (
    <Select
      {...rest}
      value={value}
      onChange={onChange}
      name={name}
      options={options}
      onSearch={setSearch}
    />
  );
};
